import { createElement, forwardRef, type HTMLAttributes, type LabelHTMLAttributes } from 'react'
import styled, { css } from 'styled-components'

interface CameraWrapperProps {
  showPlaceholder?: boolean
  detached?: boolean
}

interface ToggleButtonProps {
  hidden?: boolean
}

const ToggleButtonBase = ({ hidden, ...props }: ToggleButtonProps & LabelHTMLAttributes<HTMLLabelElement>) =>
  createElement('label', props)

export const Wrapper = styled.div`
  background-color: rgba(255, 255, 255, 1);
  color: black;
  /* width: 300px; */
  color: 100px;
  border-radius: 0.373rem;
  overflow: hidden;
`

const CameraWrapperStyled = styled.div<{ $showPlaceholder?: boolean; detached?: boolean }>`
  width: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0.41rem;
  border: 1px dashed #777;

  ${(props) =>
    props.$showPlaceholder
      ? css`
          height: 250px;
        `
      : ''}
  ${(props) =>
    props.detached
      ? css`
          position: fixed !important;
          left: 0;
          top: 0;
          visibility: hidden;
        `
      : ''}
`

export const CameraWrapper = forwardRef<HTMLDivElement, CameraWrapperProps & HTMLAttributes<HTMLDivElement>>(
  ({ showPlaceholder, detached, ...props }, ref) =>
    createElement(CameraWrapperStyled, { ...props, ref, detached, $showPlaceholder: showPlaceholder })
)
CameraWrapper.displayName = 'CameraWrapper'

export const ToggleButton = styled(ToggleButtonBase)<ToggleButtonProps>`
  width: 100%;
  padding: 1em;
  background: #eee;
  display: block;
  text-align: center;

  ${(props) =>
    props.hidden
      ? css`
          display: none;
        `
      : ''}
`

export const HiddenInput = styled.input`
  display: none;
`
